import React from "react";
import BoxFieldOption from "./BoxFieldOption";

const BoxesOptionsBar = ({ selectedField, setSelectedField }) => {
  const options = [
    {
      name: "Browse Available Box Types",
      onClick: setSelectedField,
      click: "browse",
      icon: "/icons/icon_box.png",
    },
    {
      name: "Check Your Box Types",
      onClick: setSelectedField,
      click: "check",
      icon: "/icons/icon_box.png",
    },
    {
      name: "Create a Box Type",
      onClick: setSelectedField,
      click: "create",
      icon: "/icons/icon_hand.png",
    },
  ];
  return (
    <div
      className="divRow"
      style={{
        width: "80%",
        minWidth: "1000px",
        justifyContent: "center",
      }}
    >
      {options.map((o, index) => (
        <BoxFieldOption {...o} selected={selectedField} key={index} />
      ))}
    </div>
  );
};

export default BoxesOptionsBar;
